<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded">
</app-base-template>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">SLA Violation Config</div>
  </div>
  <div class="modal-body asset-valiation-modal-body">
      <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

      <mat-tab-group mat-align-tabs="center" [selectedIndex]='selectedIndextab' (selectedTabChange)="tabClick($event)">
          <mat-tab label="Scheduler Config">

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="scheduleSelected"
              (change)="onSeduleChange($event.target.selectedIndex)">
        <option *ngFor="let Schedule of scheduleType" [value]="Schedule.id">{{Schedule.name}}</option>
      </select> 
    </div>


    <div class="form-group">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
                     placeholder="First schedule Time" [(ngModel)]="firstTime" readonly>
              <owl-date-time [pickerType]="'timer'" #dt8></owl-date-time>
    </div>
    <div class="form-group">
            <input class="form-control radius-0 font-13"[owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                     placeholder="Second schedule Time(optional)" [(ngModel)]="secondTime" readonly>
              <owl-date-time [pickerType]="'timer'" #dt1></owl-date-time>
    </div>


  </mat-tab>
  <mat-tab label="Email Config">
        <div class="form-group">
          <input type="text" class="form-control radius-0 font-13"  (keypress)="blockSpecialChar($event)" [(ngModel)]="AfterMin"
                    placeholder="Minutes After Sla Violation ">
    
        </div>

        <!-- <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="grpLvl"
                      placeholder="SupportGroup Level">
      
          </div> -->
          <div class="form-group">
            <mat-form-field class="width">
              <mat-label class = "font-13">Select Support Group Level:</mat-label>
              <mat-select [(ngModel)]="grpLvl">
              <mat-option *ngFor="let grpLvl of grpLvls" [value]="grpLvl.id"  class="font-13">{{grpLvl.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      

          <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="emailSub"
                      placeholder="Email Subject">
      
          </div>
    </mat-tab>


  </mat-tab-group>

      
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" *ngIf = "!isEmail"(click)="save()">Save</button>
    <button type="button" class="btn btn-success radius-0" *ngIf = "isEmail" (click)="submit()">Save</button>

    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>